import Link from "next/link";
import React, {useEffect, useState} from "react";
import { useSelector, useDispatch } from "react-redux";
import { buyModalHide } from "../../redux/counterSlice";
import { Confirm_checkout } from "../metamask/Metamask";
import Image from "next/image";
import {getAccountHoldersForUserId, getServerWalletForAccountHolder, getWalletBalances} from "../../utils/api";
import {getAccountHolderId, getUserId} from "../../utils/jwtUtil";

const BuyModal = () => {
  const { buyModal, projectData } = useSelector((state) => state.counter);
  const [cadrsAmount, setCadrsAmount] = useState(1); // State for CADRs amount
  const dispatch = useDispatch();
  const [accountHolderId, setAccountHolderId] = useState(null);
  const {data: serverWalletData, error: serverWalletError} = getServerWalletForAccountHolder(accountHolderId);

  useEffect(() => {
    if (projectData){
      setAccountHolderId(projectData.accountHolderId);
    }
  },[projectData]);
  
  if (!projectData) return;
  if (!serverWalletData || !Array.isArray(serverWalletData)) return;
  const accountHolderAddress = serverWalletData[0].blockchainAddress;
  
  return (
    <div>
      {/* <!-- Buy Now Modal --> */}
      <div className={buyModal ? "modal fade show block" : "modal fade"}>
        <div className="modal-dialog max-w-2xl">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title" id="buyNowModalLabel">
                Mint
              </h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => dispatch(buyModalHide())}
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="24"
                  height="24"
                  className="fill-jacarta-700 h-6 w-6 dark:fill-white"
                >
                  <path fill="none" d="M0 0h24v24H0z" />
                  <path d="M12 10.586l4.95-4.95 1.414 1.414-4.95 4.95 4.95 4.95-1.414 1.414-4.95-4.95-4.95 4.95-1.414-1.414 4.95-4.95-4.95-4.95L7.05 5.636z" />
                </svg>
              </button>
            </div>

            {/* <!-- Body --> */}
            <div className="modal-body p-6">
              <div className="mb-2 flex items-center justify-between">
                <span className="font-display text-jacarta-700 text-sm font-semibold dark:text-white">
                  Item
                </span>
              </div>

              <div className="dark:border-jacarta-600 border-jacarta-100 relative flex items-center border-t border-b py-4">
                <figure className="mr-5 self-start">
                  <Image
                    width={150}
                    height={150}
                    src={`/images/projects/${projectData.projectId}.webp`}
                    alt="avatar 2"
                    className="rounded-2lg"
                    loading="lazy"
                  />
                </figure>

                <div>
                  <h3 className="font-display text-jacarta-700 mb-1 text-base font-semibold dark:text-white">
                    {projectData.projectName}
                  </h3>
                </div>
              </div>

              {/* <!-- Total --> */}
              <div className="dark:border-jacarta-600 border-jacarta-100 mb-2 flex items-center justify-between border-b py-2.5">
                <span className="font-display text-jacarta-700 hover:text-accent font-semibold dark:text-white">
                  Total
                </span>
                <div className="ml-auto">

                  <input
                      type="number"
                      className="focus:ring-accent h-12 w-full flex-[3] border-0 focus:ring-inse dark:text-jacarta-700"
                      placeholder="Amount"
                      value={cadrsAmount} // Bind the state to input
                      onChange={(e) => setCadrsAmount(e.target.value)}
                  />
                </div>
              </div>

            </div>
            {/* <!-- end body --> */}

            <div className="modal-footer">
              <div className="flex items-center justify-center space-x-4">
                <Confirm_checkout projectData={projectData} cadrsAmount={cadrsAmount} accountHolderAddress={accountHolderAddress}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BuyModal;
